const DEFAULT_CONFIG = {
    scrollBehavior: 'smooth',
    scrollBlock: 'center',
    highlightDuration: 8000,
    maxWaitTime: 10000,
    pollInterval: 200,
};

export function scrollToWidgetById(widgetId, options = {}) {
    const config = { ...DEFAULT_CONFIG, ...options };

    if (!widgetId) {
        return;
    }

    const startTime = Date.now();

    const checkAndScroll = () => {
        const widgetElement = document.getElementById(`widget-${widgetId}`);

        if (widgetElement) {
            widgetElement.scrollIntoView({
                behavior: config.scrollBehavior,
                block: config.scrollBlock,
            });

            widgetElement.classList.add('widget-highlight');

            setTimeout(() => {
                widgetElement.classList.remove('widget-highlight');
            }, config.highlightDuration);

            return;
        }

        if (Date.now() - startTime >= config.maxWaitTime) {
            return;
        }

        setTimeout(checkAndScroll, config.pollInterval);
    };

    checkAndScroll();
}
